module.exports = __webpack_public_path__ + "img/8.b3ecf441.jpg";